import { useEffect, useState } from "react";
import {
  DeleteAdminAuctions,
  DeleteAuctions,
  GetAdminAuctions,
} from "../../../services/auctions.service";
import { IAuctions } from "../../account/tabComponents/auction.interface";
import { StatusCodes } from "http-status-codes";
import moment from "moment";
import Paginate from "../../../components/Paginate";
import TableLoader from "../../../components/TableLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Auctions = () => {
  const navigate = useNavigate();
  const [auctions, setAuctions] = useState<IAuctions>();
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const columns = [
    { title: "Auction Date", key: "date" },
    { title: "Auction Name", key: "name" },
    { title: "Location", key: "location" },
    { title: "Creation Date", key: "Creation date" },
    { title: "Deleted By", key: "deletedBy" },
    { title: "Action", key: "action" },
  ];
  //get all auctions for admin
  const GetAuctions = async (pageNumber: number) => {
    setLoading(true);
    const response = await GetAdminAuctions(pageNumber);
    if (response.status && response.status_code === StatusCodes.OK) {
      setAuctions(response.data);
    }
    setLoading(false);
  };
  useEffect(() => {
    GetAuctions(page);
  }, [page]);
  const handleDeleteAuctions = async (auction_id: number) => {
    if (window.confirm("Are you sure you want to delete?")) {
      const response = await DeleteAdminAuctions(auction_id);
      if (response.status && response.status_code === StatusCodes.OK) {
        toast.success(response.message);
        await GetAuctions(page);
      } else {
        toast.error(response.message);
      }
    }
  };
  return (
    <div>
      {loading ? (
        <TableLoader />
      ) : (
        <>
          <table className="mt-4 w-15">
            <thead>
              <tr>
                {columns.map((column) => {
                  return <th key={column.key}>{column.title}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {auctions?.data?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td>{moment(row.date).format("YYYY/MM/DD")}</td>
                    <td>{row.title}</td>
                    <td>{`${row.address} , ${row.city} , ${row.state}`}</td>
                    <td>{moment(row.created_at).format("YYYY/MM/DD")}</td>
                    <td>{row.deleted_by}</td>
                    <td>
                      <button
                        onClick={() => navigate(`/admin/auction/${row.id}`)}
                        className="border-2 px-1 border-gray-600 bg-gray-400"
                      >
                        edit
                      </button>
                      &nbsp;
                      <button
                        onClick={() => handleDeleteAuctions(row.id)}
                        className="border-2 px-1 border-gray-600 bg-gray-400"
                      >
                        delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <Paginate
            total_pages={auctions?.links!}
            page={page}
            setPage={setPage}
          />
        </>
      )}
    </div>
  );
};

export default Auctions;
